// ─── Roles — exact strings the backend stores in AdminUser.role ──────────────
export const ROLES = {
  SUPER_ADMIN: "SUPER_ADMIN",
  CONTENT_MOD: "CONTENT_MOD",
  SUBSCRIPTION_MOD: "SUBSCRIPTION_MOD",
  SUPPORT_STAFF: "SUPPORT_STAFF",
  ANALYST: "ANALYST",
  CAMPAIGN_BUILDER: "CAMPAIGN_BUILDER",
  READ_ONLY_ADMIN: "READ_ONLY_ADMIN",
};

// ─── Permissions — exact strings the backend stores in AdminUser.permissions ─
export const PERMISSIONS = {
  VIEW_ANALYTICS: "VIEW_ANALYTICS",
  READ_USERS: "READ_USERS",
  MANAGE_USERS: "READ_USERS",
  MANAGE_CONTENT: "MANAGE_CONTENT",
  VIEW_NOTIFICATIONS: "VIEW_NOTIFICATIONS",
  MANAGE_CAMPAIGNS: "MANAGE_CAMPAIGNS",
  MANAGE_MATCHES: "MANAGE_MATCHES",
  MANAGE_SYSTEM: "MANAGE_SYSTEM",
};

export const UI_PERMISSIONS = [
  PERMISSIONS.VIEW_ANALYTICS,
  PERMISSIONS.READ_USERS,
  PERMISSIONS.MANAGE_CONTENT,
  PERMISSIONS.VIEW_NOTIFICATIONS,
  PERMISSIONS.MANAGE_CAMPAIGNS,
  PERMISSIONS.MANAGE_MATCHES,
  PERMISSIONS.MANAGE_SYSTEM,
];

export const PERMISSION_LABELS = {
  [PERMISSIONS.VIEW_ANALYTICS]: "Data Analytics",
  [PERMISSIONS.READ_USERS]: "User",
  [PERMISSIONS.MANAGE_CONTENT]: "Content",
  [PERMISSIONS.VIEW_NOTIFICATIONS]: "Notification",
  [PERMISSIONS.MANAGE_CAMPAIGNS]: "Email Campaign",
  [PERMISSIONS.MANAGE_MATCHES]: "Matches",
  [PERMISSIONS.MANAGE_SYSTEM]: "App Manager",
};

// ─── Default permissions per role (mirrors backend rolePermissions map) ───────
export const ROLE_PERMISSIONS = {
  [ROLES.SUPER_ADMIN]: UI_PERMISSIONS,
  [ROLES.CONTENT_MOD]: [PERMISSIONS.MANAGE_CONTENT, PERMISSIONS.READ_USERS],
  [ROLES.SUBSCRIPTION_MOD]: [PERMISSIONS.READ_USERS, PERMISSIONS.MANAGE_SYSTEM],
  [ROLES.SUPPORT_STAFF]: [PERMISSIONS.READ_USERS],
  [ROLES.ANALYST]: [PERMISSIONS.VIEW_ANALYTICS, PERMISSIONS.READ_USERS],
  [ROLES.CAMPAIGN_BUILDER]: [PERMISSIONS.MANAGE_CAMPAIGNS, PERMISSIONS.READ_USERS, PERMISSIONS.VIEW_ANALYTICS],
  [ROLES.READ_ONLY_ADMIN]: [PERMISSIONS.VIEW_ANALYTICS],
};

export const ROLE_LABELS = {
  [ROLES.SUPER_ADMIN]: "Super Admin",
  [ROLES.CONTENT_MOD]: "Content Moderator",
  [ROLES.SUBSCRIPTION_MOD]: "Subscription Manager",
  [ROLES.SUPPORT_STAFF]: "Support Staff",
  [ROLES.ANALYST]: "Analyst",
  [ROLES.CAMPAIGN_BUILDER]: "Campaign Builder",
  [ROLES.READ_ONLY_ADMIN]: "Read Only",
};

export const ROLE_COLORS = {
  [ROLES.SUPER_ADMIN]: "#FF6B35",
  [ROLES.CONTENT_MOD]: "#4ECDC4",
  [ROLES.SUBSCRIPTION_MOD]: "#f59e0b",
  [ROLES.SUPPORT_STAFF]: "#6C63FF",
  [ROLES.ANALYST]: "#3b82f6",
  [ROLES.CAMPAIGN_BUILDER]: "#10b981",
  [ROLES.READ_ONLY_ADMIN]: "#95A5A6",
};

export const ROLE_DESCRIPTIONS = {
  [ROLES.SUPER_ADMIN]: "Full system access. Manages all admins and permissions.",
  [ROLES.CONTENT_MOD]: "Manages content and views user information.",
  [ROLES.SUBSCRIPTION_MOD]: "Manages billing and subscriptions.",
  [ROLES.SUPPORT_STAFF]: "Handles support tickets and views user info.",
  [ROLES.ANALYST]: "Views analytics and billing reports.",
  [ROLES.CAMPAIGN_BUILDER]: "Creates and manages campaigns.",
  [ROLES.READ_ONLY_ADMIN]: "Read-only access to analytics.",
};

// Roles a Super Admin can assign to other admins (SUPER_ADMIN excluded)
export const SELECTABLE_ROLES = [
  ROLES.CONTENT_MOD,
  ROLES.SUBSCRIPTION_MOD,
  ROLES.SUPPORT_STAFF,
  ROLES.ANALYST,
  ROLES.CAMPAIGN_BUILDER,
  ROLES.READ_ONLY_ADMIN,
];

export const hasPermission = (role, permission) => {
  if (!role || !permission) return false;
  if (role === ROLES.SUPER_ADMIN) return true;
  return (ROLE_PERMISSIONS[role] || []).includes(permission);
};
